export class DeskTopTrigger {
    parserScrollEvent(e) {
        return e ? !(e.ctrlKey || 0 === e.deltaY && 0 === e.deltaX) && (e.scrollX = e.deltaX, 
        e.scrollY = e.deltaY, e) : e;
    }
    parserZoomEvent(e) {
        if (!e) return e;
        const zoom = Math.pow(1.0005, -e.deltaY * Math.pow(16, e.deltaMode));
        return e.zoomDelta = zoom, e.zoomX = e.canvasX, e.zoomY = e.canvasY, e;
    }
    clearZoom() {}
    clearScroll() {}
    clearDrag() {}
    parserDragEvent() {
        return !0;
    }
}
//# sourceMappingURL=desktop.js.map
